import {forwardRef} from "react";
import {clsx} from "clsx";
import {ChevronDown} from "lucide-react";

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  helperText?: string;
  options: Array<{value: string | number; label: string; disabled?: boolean}>;
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({label, error, helperText, options, className = "", ...props}, ref) => {
    return (
      <div className="w-full">
        {label && <label className="form-label">{label}</label>}

        <div className="relative">
          <select
            ref={ref}
            className={clsx(
              "form-input appearance-none pr-10",
              error &&
                "border-danger-500 focus:border-danger-500 focus:ring-danger-500",
              className
            )}
            {...props}
          >
            {options.map((option) => (
              <option
                key={option.value}
                value={option.value}
                disabled={option.disabled}
              >
                {option.label}
              </option>
            ))}
          </select>

          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <ChevronDown className="w-4 h-4 text-gray-400 dark:text-gray-500" />
          </div>
        </div>

        {error && <p className="form-error">{error}</p>}

        {helperText && !error && (
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
            {helperText}
          </p>
        )}
      </div>
    );
  }
);

Select.displayName = "Select";
export default Select;
